var Layout   = require("enyo/Layout"),
    clipText = require("app/utils/clipText"),
    dom      = require("enyo/dom"),
    kind     = require("enyo/kind");

module.exports = kind(/** @lends  app.PodcastPage.PodcastEpisodeLayout.prototype */ {

    /**
     * @private
     */
    name: "app.PodcastPage.PodcastEpisodeLayout",

    /**
     * @private
     */
    kind: Layout,

    /**
     * @public
     */
    reflow: function() {
        var container  = this.container,
            thumbnailWidth,
            thumbnailHeight,
            $thumbnail = container.$.thumbnail,
            thumbnailNode,
            bodyNode,
            bodyHeight;

        if (!container.hasNode()) {
            return;
        }

        // Thumbnail dimensions
        thumbnailNode = $thumbnail.hasNode();

        if (thumbnailNode) {
            // Reset dimensions
            $thumbnail.setBounds({
                width:  "auto",
                height: "auto"
            });

            // Adjust height
            thumbnailWidth  = thumbnailNode.offsetWidth;
            thumbnailHeight = $thumbnail.calcHeight(thumbnailWidth);
            $thumbnail.setBounds({
                width:  thumbnailWidth + "px",
                height: thumbnailHeight + "px"
            });
        }

        // Clean slate
        bodyNode = container.$.body.hasNode();
        clipText.unclip(bodyNode);

        // Limit max body height to 3 lines
        bodyHeight = parseFloat(dom.getComputedStyleValue(bodyNode, "line-height"), 10) * 3;
        clipText.clip(bodyNode, bodyHeight, true);
    }

});
